<template>
  <div id="personalCheckin" class="Content-Page">
    <!-- <canvas id="canvas" width="750" height="500">your canvas loads here</canvas> -->
    <canvas id="canvas" width="750" height="0">your canvas loads here</canvas>
    <div id="namePage" class="wrap-Main">
      <div class="box-S4">
        <div class="N-Page T-size-36">Electronic Form</div>
      </div>
    </div>
    <div id="personalDetail" class="wrap-Main">
      <div class="box-S4">
        <div class="B-passenger">
          <div class="b-person">
            <div class="b-display">
              <div class="B-display"></div>
            </div>
            <div class="b-name-company">
              <p class="t-name T-size-20">{{ u_firstname }} {{ u_lastname }}</p>
              <!-- <div class="t-company">Company : {{c_name}}</div> -->
              <!-- Edit -->
              <div class="t-company">Customer : {{ customerName }}</div>
              <div></div>
            </div>
          </div>

          <div class="b-detail">
            <div class="t-title">Personal Data</div>
            <div class="box-S4 flex-between-center t-detail">
              <div class="bL">
                <span class="T-size-14">Gender</span>
                <p class="T-size-16">{{ u_gender }}</p>
              </div>
              <div class="bR">
                <span class="T-size-14">Telephone</span>
                <p class="T-size-16">{{ u_telephone }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>

      <div class="box-S4">
        <div class="B-carddetail">
          <NurseTest :passengerID="$route.params.id" :f_id="$route.params.f_id"  ref="NurseTest" />
        </div>
      </div>
      <div class="line"></div>

      <!-- <div class="box-S4">
        <div class="N-Page">
          <div class>
            <span class="T-size-24">Alcohol, Temperature and Blood Pressure Test</span>
          </div>
        </div>
      </div>
      <div class="T-size-16">
        Conditions : Alcohol &lt; {{ alcoholLimit }} mg. / Temperature &lt;
        {{ tempLimit }}
        &deg;C
      </div>
      <div class="B-alcoholTemp-Main alcohol">
        <div v-for="item in ArrlistAddAlcohol" :key="item.at_id">
          <div class="B-alcoholTemp nopass" v-show="item.at_status == '0'">
            <div class="b-alcoholTemp-name">
              <div class="box-S4 flex-between-center noPadding">
                <div class="bL T-size-18 SemiBold" v-if="item.at_value_test >= 0">
                  Alcohol : {{ item.at_value_test }} mg
                </div>
                <div class="bL T-size-18 SemiBold" v-else>Alcohol : N/A</div>
                <div class="bR T-size-18 SemiBold">
                  Temperature : {{ item.at_value_temp }} &deg;C
                </div>
              </div>
              <div>Report By : {{ item.at_report_by }}</div>
              <div>
                Date &amp; Time :
                {{ item.at_value_date }}
              </div>
            </div>
          </div>
          <div class="B-alcoholTemp pass" v-show="item.at_status == '1'">
            <div class="b-alcoholTemp-name">
              <div class="box-S4 flex-between-center noPadding">
                <div class="bL T-size-18 SemiBold" v-if="item.at_value_test >= 0">
                  Alcohol : {{ item.at_value_test }} mg
                </div>
                <div class="bL T-size-18 SemiBold" v-else>Alcohol : N/A</div>
                <div class="bR T-size-18 SemiBold">
                  Temperature : {{ item.at_value_temp }} &deg;C
                </div>
              </div>
              <div>Report By : {{ item.at_report_by }}</div>
              <div>
                Date &amp; Time :
                {{ item.at_value_date }}
              </div>
            </div>
          </div>
        </div>
        <div class="box-btn">
          <v-btn class="theme-btn-even" v-show="
            ArrlistAddAlcohol.length < 3 &&
            ArrDataPassenger.as_id < 4 &&
            at_statusNow != true &&
            userdata.r_id == 16
          " @click="addItemAlcohol()">
            <span class="I-create"></span>
            <span>Alcohol and Temperature Test</span>
          </v-btn>
        </div>
      </div> -->
    </div>

    <div id="alcoholTemperature" class="wrap-Main">

      <div id="selectSeat" class="box-S4">
        <div class="N-Page">
          <div class>
            <span class="T-size-24">Medicine Declaration Form</span>
          </div>
        </div>
      </div>
      <div class="box-S4">
        <div class="B-carddetail B-formMain">
          <div class="b-row">
            <div class="box-S4">
              <div class="B-carddetail">
                <v-btn v-if="(consentHealthScreenForm == null &&
                    nurseStatusHealthScreenForm == null) ||
                  (consentHealthScreenForm == null &&
                    nurseStatusHealthScreenForm == 'No Data')
                  " class="theme-btn-even center Bsize190" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">No Data</span>
                  <v-icon style="padding-left: 5px">mdi-block-helper</v-icon>
                </v-btn>
                <v-btn v-if="consentHealthScreenForm == true &&
                  nurseStatusHealthScreenForm == 'Wait'
                  " class="theme-btn-even center Bsize190 btn-checkin" :disabled="userdata.r_id != 16"
                  @click="OpenDailogNurse(1, 'Medicine Declaration Form')">
                  <span class="T-size-18">Wait</span>
                  <v-icon style="padding-left: 5px">mdi-alarm</v-icon>
                </v-btn>
                <v-btn v-if="consentHealthScreenForm == true &&
                  nurseStatusHealthScreenForm != null &&
                  nurseStatusHealthScreenForm == 'Passed'
                  " class="theme-btn-even center Bsize190 btn-viewcheckin" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">Passed</span>
                  <v-icon style="padding-left: 5px">mdi-check</v-icon>
                </v-btn>
                <v-btn v-if="consentHealthScreenForm == true &&
                  nurseStatusHealthScreenForm != null &&
                  nurseStatusHealthScreenForm == 'Failed'
                  " class="theme-btn-even center Bsize190 btn-delete" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">Failed</span>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusHealthScreenForm != 'No Data'" @click="PrintHealthForm(1)">
                <span class="T-size-18">View</span>
                <v-icon style="padding-left: 5px">mdi-file-document-outline</v-icon>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusHealthScreenForm != 'No Data'" @click="PrintHealthForm(2)">
                <span class="T-size-18">Download</span>
                <v-icon style="padding-left: 5px">mdi-tray-arrow-down</v-icon>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusHealthScreenForm == 'Wait'" @click="() => { dialogConfirmDelete = true; fromdel = 1 }">
                <span class="T-size-18">Clear Answers</span>
                <v-icon style="padding-left: 5px">mdi-delete</v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>


      <!-- <div id="selectSeat" class="box-S4">
        <div class="N-Page">
          <div class>
            <span class="T-size-24">SCREENING QUESTIONNAIRE COVID-19 and Monkeypox:</span>
          </div>
        </div>
      </div>
      <div class="box-S4">
        <div class="B-carddetail B-formMain">
          <div class="b-row">
            <div class="box-S4">
              <div class="B-carddetail">
                <v-btn v-if="
                  (consentScreeningCOVIDForm == null &&
                    nurseStatusScreeningCOVIDForm == null) ||
                  (consentScreeningCOVIDForm == null &&
                    nurseStatusScreeningCOVIDForm == 'No Data')
                " class="theme-btn-even center Bsize190" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">No Data</span>
                  <v-icon style="padding-left: 5px">mdi-block-helper</v-icon>
                </v-btn>
                <v-btn v-if="
                  consentScreeningCOVIDForm == true &&
                  nurseStatusScreeningCOVIDForm == 'Wait'
                " class="theme-btn-even center Bsize190 btn-checkin" :disabled="userdata.r_id != 16"
                  @click="OpenDailogNurse(2, 'COVID-19 and Monkeypox')">
                  <span class="T-size-18">Wait</span>
                  <v-icon style="padding-left: 5px">mdi-alarm</v-icon>
                </v-btn>
                <v-btn v-if="
                  consentScreeningCOVIDForm == true &&
                  nurseStatusScreeningCOVIDForm != null &&
                  nurseStatusScreeningCOVIDForm == 'Passed'
                " class="theme-btn-even center Bsize190 btn-viewcheckin" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">Passed</span>
                  <v-icon style="padding-left: 5px">mdi-check</v-icon>
                </v-btn>
                <v-btn v-if="
                  consentScreeningCOVIDForm == true &&
                  nurseStatusScreeningCOVIDForm != null &&
                  nurseStatusScreeningCOVIDForm == 'Failed'
                " class="theme-btn-even center Bsize190 btn-delete" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">Failed</span>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusScreeningCOVIDForm != 'No Data'" @click="PrintCovidForm(1)">
                <span class="T-size-18">View</span>
                <v-icon style="padding-left: 5px">mdi-file-document-outline</v-icon>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusScreeningCOVIDForm != 'No Data'" @click="PrintCovidForm(2)">
                <span class="T-size-18">Download</span>
                <v-icon style="padding-left: 5px">mdi-tray-arrow-down</v-icon>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusScreeningCOVIDForm == 'Wait'" @click="() => { dialogConfirmDelete = true; fromdel = 2 }">
                <span class="T-size-18">Clear Answers</span>
                <v-icon style="padding-left: 5px">mdi-delete</v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div> -->

      <div id="selectSeat" class="box-S4">
        <div class="N-Page">
          <div class>
            <span class="T-size-24">Alcohol & Urine Controlled Drugs Test Consent and Policy Compliance Declaration
              Form</span>
          </div>
        </div>
      </div>
      <div class="box-S4">
        <div class="B-carddetail B-formMain">
          <div class="b-row">
            <div class="box-S4">
              <div class="B-carddetail">
                <v-btn v-if="(consentAlcoholUrineForm == null &&
                    nurseStatusAlcoholUrineForm == null) ||
                  (consentAlcoholUrineForm == null &&
                    nurseStatusAlcoholUrineForm == 'No Data')
                  " class="theme-btn-even center Bsize190" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">No Data</span>
                  <v-icon style="padding-left: 5px">mdi-block-helper</v-icon>
                </v-btn>
                <v-btn v-if="consentAlcoholUrineForm == true &&
                  nurseStatusAlcoholUrineForm == 'Wait'
                  " class="theme-btn-even center Bsize190 btn-checkin" :disabled="userdata.r_id != 16"
                  @click="OpenDailogNurse(3, 'Alcohol & Urine Controlled Drugs Test')">
                  <span class="T-size-18">Wait</span>
                  <v-icon style="padding-left: 5px">mdi-alarm</v-icon>
                </v-btn>
                <v-btn v-if="consentAlcoholUrineForm == true &&
                  nurseStatusAlcoholUrineForm != null &&
                  nurseStatusAlcoholUrineForm == 'Passed'
                  " class="theme-btn-even center Bsize190 btn-viewcheckin" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">Passed</span>
                  <v-icon style="padding-left: 5px">mdi-check</v-icon>
                </v-btn>
                <v-btn v-if="consentAlcoholUrineForm == true &&
                  nurseStatusAlcoholUrineForm != null &&
                  nurseStatusAlcoholUrineForm == 'Failed'
                  " class="theme-btn-even center Bsize190 btn-delete" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">Failed</span>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusAlcoholUrineForm != 'No Data'" @click="PrintAlcoholForm(1)">
                <span class="T-size-18">View</span>
                <v-icon style="padding-left: 5px">mdi-file-document-outline</v-icon>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusAlcoholUrineForm != 'No Data'" @click="PrintAlcoholForm(2)">
                <span class="T-size-18">Download</span>
                <v-icon style="padding-left: 5px">mdi-tray-arrow-down</v-icon>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="nurseStatusAlcoholUrineForm == 'Wait'" @click="() => { dialogConfirmDelete = true; fromdel = 3 }">
                <span class="T-size-18">Clear Answers</span>
                <v-icon style="padding-left: 5px">mdi-delete</v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>

      <!-- <div id="selectSeat" class="box-S4">
        <div class="N-Page">
          <div class>
            <span class="T-size-24">แบบสำแดงยืนยันปฏิบัติตามนโยบายด้านสิ่งเสพติดและแอลกอฮอล์</span>
          </div>
        </div>
      </div>
      <div class="box-S4">
        <div class="B-carddetail B-formMain">
          <div class="b-row">
            <div class="box-S4">
              <div class="B-carddetail">
                <v-btn v-if="consentDeclarationForm != 'consented'" class="theme-btn-even center Bsize190"
                  :disabled="userdata.r_id != 16">
                  <span class="T-size-18">No Data</span>
                  <v-icon style="padding-left: 5px">mdi-block-helper</v-icon>
                </v-btn>
                <v-btn v-else class="theme-btn-even center Bsize190 btn-viewcheckin" :disabled="userdata.r_id != 16">
                  <span class="T-size-18">Pass</span>
                  <v-icon style="padding-left: 5px">mdi-check</v-icon>
                </v-btn>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="consentDeclarationForm == 'consented'" @click="PrintDeclarationForm(1)">
                <span class="T-size-18">View</span>
                <v-icon style="padding-left: 5px">mdi-file-document-outline</v-icon>
              </div>
              <div class="B-carddetail center Bsize190" style="padding-top:17px;"
                v-show="consentDeclarationForm == 'consented'" @click="PrintDeclarationForm(2)">
                <span class="T-size-18">Download</span>
                <v-icon style="padding-left: 5px">mdi-tray-arrow-down</v-icon>
              </div>
            </div>
          </div>
        </div>
      </div> 
      <div class="line"></div>-->
    </div>

    <!-- Dialog Temperature -->
    <v-dialog v-model="dialogAlcoholAndTemperature" persistent max-width="400">
      <v-card id="dialog" class="TF type2">
        <div class="b-content">
          <div class="B-dialogform">
            <div class="t-namepage">Alcohol And Temperature Test</div>
            <div class="b-form">
              <v-text-field label="Alcohol Degree" type="number" v-model="at_value_test" suffix="mg."></v-text-field>
            </div>
            <div class="b-form">
              <v-text-field label="Temperature Degree" type="number" v-model="at_value_temp" suffix="°C"></v-text-field>
            </div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-cancel Bsize100" text @click="dialogAlcoholAndTemperature = false">
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn class="theme-btn-even btn-save Bsize100" text @click="SaveAlcoholAndTemperature()">
              <span class="T-size-18">Save</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNurse" persistent max-width="500" fullscreen>
      <v-card id="dialog" class="TF type2">
        <div class="b-content">
          <div class="B-dialogform">
            <div class="t-namepage">{{ dialogNurseTitle }}</div>
            <div class="b-form">
              <v-select class="hideMessage" v-model="nurseStatus" :items="itemsListNurseStatus" label="*Status"
                item-text="ns_name" item-value="ns_id" return-object></v-select>
            </div>
            <div class="b-form">
              <v-text-field v-model="advice" label="*Advice"></v-text-field>
            </div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-cancel Bsize100" text @click="dialogNurse = false">
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn class="theme-btn-even btn-save Bsize100" text @click="OpenDialogConfirmSaveNurse()">
              <span class="T-size-18">Save</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmSaveNurse" persistent max-width="300">
      <v-card id="dialog" class="TF type1">
        <div class="b-content">
          <div class="B-dialog save">
            <div class="t-title">{{ dialogNurseTitle }}</div>
            <div class="t-des">
              <div>{{ u_firstname }} {{ u_lastname }}</div>
              <div v-if="nurseStatus != null && nurseStatus.ns_name == 'Passed'" class="boxstatuspassed">
                <b>{{ nurseStatus.ns_name }}</b>
              </div>
              <div v-if="nurseStatus != null && nurseStatus.ns_name == 'Failed'" class="boxstatusfailed">
                <b>{{ nurseStatus.ns_name }}</b>
              </div>
            </div>
            <div class="box-S4"></div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-cancel Bsize100" text @click="dialogConfirmSaveNurse = false">
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn class="theme-btn-even btn-save Bsize100" text @click="SaveNurse()">
              <span class="T-size-18">Confirm</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmDelete" persistent max-width="300">
      <v-card id="dialog" class="TF type1">
        <div class="b-content">
          <div class="B-dialog delete">
            <div class="t-title">Confirm To Delete ?</div>
            <div class="t-des">
              <div>Are you sure to Delete this item?</div>
              <div>{{ u_firstname }} {{ u_lastname }}</div>
              <div v-if="nurseStatus != null && nurseStatus.ns_name == 'Passed'" style="color:green; font-size: 25px;">
                <b>{{ nurseStatus.ns_name }}</b>
              </div>
              <div v-if="nurseStatus != null && nurseStatus.ns_name == 'Failed'" style="color:red; font-size: 25px;">
                <b>{{ nurseStatus.ns_name }}</b>
              </div>
            </div>
            <div class="box-S4"></div>
          </div>
          <div class="box-btn">
            <v-btn class="theme-btn-even btn-cancel Bsize100" text @click="dialogConfirmDelete = false">
              <span class="T-size-18">cancel</span>
            </v-btn>
            <v-btn class="theme-btn-even btn-save Bsize100" text @click="Cancleform()">
              <span class="T-size-18">Confirm</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- Sign Signature -->
    <div id="personSignature" class="wrap-Main" v-if="userdata.r_id == 16">
      <div class="box-S4">
        <div class="N-Page">
          <div class>
            <span class="T-size-24">Signature (NURSE)</span>
          </div>
        </div>
      </div>
      <div class="box-S4" v-show="nurse_singature == null">
        <div class="B-carddetail B-formMain">
          <div class="b-signature">
            <div class="b-sign">
              <!-- ใส่ Script Sign -->
              <VueSignaturePad width="100%" height="500px" ref="signaturePad" :options="options" />
            </div>
          </div>
          <div class="box-S4 flex-between-center">
            <v-text-field class="hideMessage input-date" v-model="nurse_fullname" label="Please fill your name.">
            </v-text-field>
          </div>

          <div class="box-S4 flex-between-center">
            <div class="b-btnSave">
              <v-btn class="theme-btn-even btn-cancle Bsize150" @click="UndoSignature()">
                <span class="T-size-18">Clear</span>
              </v-btn>
              <v-btn class="theme-btn-even btn-sign Bsize150" @click="SaveSignatureToDB()">
                <span class="I-sign2"></span>
                <span class="T-size-18">Sign</span>
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <v-dialog v-model="dialogWarningInsertYourName" persistent max-width="300">
        <v-card id="dialog" class="TF type1">
          <div class="b-content">
            <div class="B-dialog warning3">
              <div class="t-title">Warning</div>
              <div class="t-des">
                <div>Please fill your name.</div>
              </div>
              <div class="box-S4"></div>
            </div>
            <div class="box-btn">
              <v-btn class="theme-btn-even btn-save Bsize100" text @click="dialogWarningInsertYourName = false">
                <span class="T-size-18">OK</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogWarningSign" persistent max-width="300">
        <v-card id="dialog" class="TF type1">
          <div class="b-content">
            <div class="B-dialog warning3">
              <div class="t-title">Warning</div>
              <div class="t-des">
                <div>Please sign your name.</div>
              </div>
              <div class="box-S4"></div>
            </div>
            <div class="box-btn">
              <v-btn class="theme-btn-even btn-save Bsize100" text @click="dialogWarningSign = false">
                <span class="T-size-18">OK</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <!-- Sign Signature -->

      <!--Show Img Signature -->
      <div class="box-S4" v-show="nurse_singature != null">
        <div class="B-carddetail B-formMain">
          <div class="b-condition">
            <v-img class="center" max-width="750px" :src="nurse_singature"></v-img>
          </div>
          <div style="text-align: center">
            <div class="flex-center">
              {{ nurse_sign_date | yyyyMMddHHmmAdd7Hour }}<br />
              {{ nurse_fullname }}
            </div>
          </div>
        </div>
      </div>

      <div class="line"></div>
    </div>
    <!--Show Img Signature -->

    <div id="partBack" class="wrap-Main">
      <div class="box-S4">
        <v-btn text class="ColorTheme-S white--text theme-btn" @click="Back()">
          <span class="I-back"></span>
          <span>Back</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import fillerdate from "../utils/filterdate";
import feathersClientUOA from "../plugins/feathers-client-uoa";
import { differenceInDays, format, addHours } from "date-fns";
import uploadBlob from "../utils/uploadBlob";
import { Nurseform } from "../utils/NurseForm";
import NurseTest from '../components/nurse/NurseTest'
export default {
  data: () => ({
    idPass: "",
    customerName: "",
    customerId: "",
    companyName: "",
    destination: "",

    checkbox1: true,
    checkInDateTime: null,
    formNo: 0,
    dialogNurse: false,
    dialogNurseTitle: "",
    dialogConfirmSaveNurse: false,

    advice: "",
    nurseStatus: null,

    itemsListNurseStatus: [
      { ns_id: 1, ns_name: "Passed" },
      { ns_id: 2, ns_name: "Failed" },
    ],

    ArrDataPassenger: [],
    tempLimit: "",
    dialogAlcoholAndTemperature: false,
    alcoholLimit: "",
    fullname: "",
    flightno: "",
    idFlight: "",

    u_firstname: "",
    u_lastname: "",
    c_name: "",
    u_emergency_contact: "",
    u_emergency_relation: "",
    u_emergency_telephone: "",
    u_gender: "",
    u_telephone: "",

    p_body_weight: "",
    p_seat_no: "",
    p_rfid: "",
    offload: "",
    offload_remark: "",
    bg_weight: "",
    at_statusNow: null,
    at_report_by: "",
    at_value_test: "",
    at_value_date: "",
    at_value_temp: "",
    at_status: "",

    itemsDataAlcohol: [],
    ArrlistAddAlcohol: [],
    userdata: "",
    options: {
      penColor: "#00f",
      minWidth: 3,
      maxWidth: 3,
    },

    // แบบสำแดง DeclarationForm
    declareID: "",
    accept1: "",
    accept2: "",
    accept3: "",
    accept4: "",
    accept5: "",
    accept6: "",
    accept7: "",
    accept8: "",

    medicine1: "",
    medicine2: "",
    medicine3: "",
    medicine4: "",
    medicine5: "",
    medicine6: "",
    medicine7: "",
    medicine8: "",
    medicine9: "",
    medicine10: "",
    medicine11: "",
    other: "",
    otherDetail: "",
    consentDeclarationForm: "",
    // แบบสำแดง DeclarationForm

    consentHealthScreenForm: "",
    nurseStatusHealthScreenForm: "",
    consentScreeningCOVIDForm: "",
    // nurseStatusScreeningCOVIDForm: "",
    consentAlcoholUrineForm: "",
    nurseStatusAlcoholUrineForm: "",
    nurseSign: false,
    nurse_singature: null,
    nurse_sign_date: null,

    signImage: "",
    signDateTime: new Date(),
    nurse_fullname: "",
    dialogConfirmDelete: false,
    fromdel: 0,
    dialogWarningInsertYourName: false,
    dialogWarningSign: false,
  }),
  props: [],
  components: {
    NurseTest
  },
  async mounted() {
    this.userdata = await this.$CurrentUser.GetCurrentUser();
    this.idPass = this.$route.params.id;
    this.customerName = this.$route.params.customerName;
    this.customerId = this.$route.params.customerId;
    this.companyName = this.$route.params.companyName;
    this.destination = this.$route.params.destination;

    this.DataPassengerFromDB();
    this.DataAlcoholTestFromDB();
    this.RenderDeclarationForm();
    this.DataEForm();
  },
  computed: {
    formTitle() {
      return this.modeEvent === "create" ? "Add" : "Edit";
    },
  },
  methods: {
    async DataEForm() {
      //E - FORM
      var q = {};
      q.p_id = this.idPass;
      var res = await feathersClientUOA
        .service("viewcheckinpassenger-2")
        .find({ query: q });
      let data = res.data[0];
      this.consentHealthScreenForm = data.mhf_consent;
      this.nurseStatusHealthScreenForm = data.mhf_status;
      this.consentScreeningCOVIDForm = data.mcf_consent;
      // this.nurseStatusScreeningCOVIDForm = data.mcf_status;
      this.consentAlcoholUrineForm = data.maf_consent;
      this.nurseStatusAlcoholUrineForm = data.maf_status;
      this.nurse_singature = data.mhf_nurse_singature;
      this.nurse_sign_date = data.mhf_nurse_sign_date;
      this.nurse_fullname = data.mhf_nurse_sign_name;

      if (this.nurseStatusHealthScreenForm == null) {
        this.nurseStatusHealthScreenForm = "No Data";
      }
      // if (this.nurseStatusScreeningCOVIDForm == null) {
      //   this.nurseStatusScreeningCOVIDForm = "No Data";
      // }
      if (this.nurseStatusAlcoholUrineForm == null) {
        this.nurseStatusAlcoholUrineForm = "No Data";
      }
      //E - FORM
    },
    async DataPassengerFromDB() {
      try {
        var q = {};
        q.p_id = this.idPass;
        var res = await feathersClientUOA
          .service("viewcheckinpassenger-2")
          .find({ query: q });
        this.ArrDataPassenger = res.data[0];
        this.u_idcard_no = this.ArrDataPassenger.u_idcard_no;
        this.u_firstname = this.ArrDataPassenger.u_firstname;
        this.u_lastname = this.ArrDataPassenger.u_lastname;
        this.fullname = this.u_firstname + "  " + this.u_lastname;
        this.flightno = this.ArrDataPassenger.f_flight_no;
        this.c_name = this.ArrDataPassenger.c_name;
        this.u_emergency_contact = this.ArrDataPassenger.u_emergency_contact;
        this.u_emergency_relation = this.ArrDataPassenger.u_emergency_relation;
        this.u_emergency_telephone =
          this.ArrDataPassenger.u_emergency_telephone;
        this.u_telephone = this.ArrDataPassenger.u_telephone;
        this.idFlight = this.ArrDataPassenger.f_id;
        //Add
        if (this.ArrDataPassenger.o_alcohol_limit == null) {
          this.alcoholLimit = 0.02;
        } else {
          this.alcoholLimit = parseFloat(
            this.ArrDataPassenger.o_alcohol_limit
          ).toFixed(2);
        }

        if (this.ArrDataPassenger.o_temp_limit == null) {
          this.tempLimit = 37.3;
        } else {
          this.tempLimit = parseFloat(
            this.ArrDataPassenger.o_temp_limit
          ).toFixed(2);
        }
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },

    async DataAlcoholTestFromDB() {
      try {
        this.ArrlistAddAlcohol = [];
        var q = {};
        q.p_id = this.idPass;
        q.retire = "0";
        var res = await feathersClientUOA
          .service("alcoholtest")
          .find({ query: q });
        this.itemsDataAlcohol = res.data;

        this.itemsDataAlcohol.forEach((element) => {
          var newArrayBinding = {};
          newArrayBinding["at_id"] = element.at_id;
          newArrayBinding["at_status"] = element.at_status;
          newArrayBinding["at_report_by"] = element.at_report_by;
          newArrayBinding["at_value_test"] = parseFloat(
            element.at_value_test
          ).toFixed(2);
          newArrayBinding["at_value_date"] = format(
            new Date(element.at_value_date),
            "dd-MM-yyyy HH:mm"
          );
          newArrayBinding["at_value_temp"] = parseFloat(
            element.at_value_temp
          ).toFixed(2);
          this.ArrlistAddAlcohol.push(newArrayBinding);
        });

        var q = {};
        q.c_id = this.ArrDataPassenger.c_id;

        var res = await feathersClientUOA.service("company").find({ query: q });
        this.itemsDataCompany = res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async addItemAlcohol() {
      this.at_value_test = "";
      this.at_value_temp = "";
      this.dialogAlcoholAndTemperature = true;
    },
    async SaveAlcoholAndTemperature() {
      this.ArrlistAddAlcohol = [];
      if (this.customerId == 4) {
        if (this.at_value_temp != "") {
          var DateTime = format(new Date(), "dd-MM-yyyy HH:mm");
          let temp_limit = this.tempLimit;

          let status = "";
          let temp = parseFloat(this.at_value_temp);

          if (temp <= temp_limit) {
            status = 1;
            this.at_statusNow = true;
          } else {
            status = 0;
            this.at_statusNow = false;
          }

          var newArrayBinding = {};
          newArrayBinding["at_id"] = null;
          newArrayBinding["at_status"] = status;
          newArrayBinding["at_report_by"] = this.userdata.FullName;
          newArrayBinding["at_value_test"] = this.at_value_test;
          newArrayBinding["at_value_date"] = DateTime;
          newArrayBinding["at_value_temp"] = parseFloat(
            this.at_value_temp
          ).toFixed(2);

          this.ArrlistAddAlcohol.push(newArrayBinding);
        }
      } else {
        if (this.at_value_test != "" && this.at_value_temp != "") {
          var DateTime = format(new Date(), "dd-MM-yyyy HH:mm");
          let alcohol_limit = this.alcoholLimit;
          let temp_limit = this.tempLimit;

          let status = "";
          let test = parseFloat(this.at_value_test);
          let temp = parseFloat(this.at_value_temp);

          if (test <= alcohol_limit && temp <= temp_limit) {
            status = 1;
            this.at_statusNow = true;
          } else {
            status = 0;
            this.at_statusNow = false;
          }

          var newArrayBinding = {};
          newArrayBinding["at_id"] = null;
          newArrayBinding["at_status"] = status;
          newArrayBinding["at_report_by"] = this.userdata.FullName;
          newArrayBinding["at_value_test"] = parseFloat(
            this.at_value_test
          ).toFixed(2);
          newArrayBinding["at_value_date"] = DateTime;
          newArrayBinding["at_value_temp"] = parseFloat(
            this.at_value_temp
          ).toFixed(2);

          this.ArrlistAddAlcohol.push(newArrayBinding);
        }
      }
      await this.SaveAlcoholEditToDB();

      this.dialogAlcoholAndTemperature = false;
    },
    async SaveAlcoholEditToDB() {
      this.ArrlistAddAlcohol.forEach((element) => {
        if (element.at_id == null) {
          let DataAdd = {
            p_id: this.idPass,
            at_report_by: element.at_report_by,
            at_value_test: element.at_value_test,
            at_value_date: new Date(),
            at_value_temp: element.at_value_temp,
            at_status: element.at_status,
            retire: 0,
          };
          if (element.at_status == 1) {
            this.UpdatePassengertodb();
          }
          this.CreateAlcohol(DataAdd);
        }
      });
      this.DataAlcoholTestFromDB();
    },
    async CreateAlcohol(DataAdd) {
      try {
        var res = await feathersClientUOA
          .service("alcoholtest")
          .create(DataAdd);
      } catch (error) {
        console.log(error);
      }
    },
    async UpdatePassengertodb() {
      try {
        var res = await feathersClientUOA
          .service("passenger")
          .patch(this.idPass, { as_id: 4 });
      } catch (error) {
        console.log(error);
      }
    },
    async UndoSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    async SaveSignatureToDB() {
      const dataURL = this.$refs.signaturePad.saveSignature();
      if (dataURL.isEmpty != true) {
        if (this.nurse_fullname != null && this.nurse_fullname != '') {
          const resSignature = await uploadBlob(dataURL.data);
          try {
            let q1 = {};
            q1.p_id = this.idPass;
            let res1 = await feathersClientUOA.service("mubadala-health-form-2").find({ query: q1 });
            if (res1.total == 1) {
              let mhf_id = res1.data[0].mhf_id;

              let dataSignatureForm1 = {
                mhf_nurse_singature: resSignature.data.Url,
                mhf_nurse_sign_date: new Date(),
                mhf_nurse_sign_name: this.nurse_fullname,
              };
              await feathersClientUOA.service("mubadala-health-form-2").patch(mhf_id, dataSignatureForm1);
            }

            // let q2 = {};
            // q2.p_id = this.idPass;
            // let res2 = await feathersClientUOA
            //   .service("mubadala-covid-form-2")
            //   .find({ query: q2 });
            // if (res2.total == 1) {
            //   let mcf_id = res2.data[0].mcf_id;
            //   let dataSignatureForm2 = {
            //     mcf_nurse_signature: resSignature.data.Url,
            //     mcf_nurse_sign_date: new Date(),
            //     mcf_nurse_sign_name: this.nurse_fullname,
            //   };
            //   await feathersClientUOA
            //     .service("mubadala-covid-form-2")
            //     .patch(mcf_id, dataSignatureForm2);
            // }

            let q3 = {};
            q3.p_id = this.idPass;
            let res3 = await feathersClientUOA.service("mubadala-alcohol-form-2").find({ query: q3 });
            if (res3.total == 1) {
              let maf_id = res3.data[0].maf_id;
              let dataSignatureForm3 = {
                maf_nurse_signature: resSignature.data.Url,
                maf_nurse_sign_date: new Date(),
                maf_nurse_sign_name: this.nurse_fullname,
              };
              await feathersClientUOA.service("mubadala-alcohol-form-2").patch(maf_id, dataSignatureForm3);
            }

            let q4 = {};
            q4.p_id = this.idPass;
            let res4 = await feathersClientUOA.service("mubadala-test-record-form").find({ query: q4 });
            if (res4.total == 1) {
              let maf_id = res4.data[0].trf_id;
              let dataSignatureForm4 = {
                trf_nurse_singature: resSignature.data.Url,
                trf_mau_nurse_sign_date: new Date(),
                trf_nurse_sign_name: this.nurse_fullname,
              };
              await feathersClientUOA.service("mubadala-test-record-form").patch(maf_id, dataSignatureForm4);
            }
            //SEQ
            let properties = {
              f_id: parseInt(this.$route.params.f_id),
              p_id: parseInt(this.idPass),
              trf_mau_nurse_sign_date: new Date(),
              trf_nurse_sign_name: this.nurse_fullname
            };
            this.$log.Info('{action} by {username} ({role}) : f_id={f_id}, p_id={p_id}', { action: "NurseSignEForm", username: this.userdata.u_username, role: this.userdata.r_name, ...properties });

            this.Back();
          } catch (error) {
            //SEQ LOG
            this.$log.Error("NurseSignEForm, Error : {error}", { error });
            console.log("NurseSignEForm, Error : {error}" + error);
          }
        } else {
          this.dialogWarningInsertYourName = true;
        }
      } else {
        this.dialogWarningSign = true;
      }
    },

    Back() {
      this.$router.go(-1);
    },

    CheckInDateTime() {
      this.checkInDateTime = new Date().toISOString();
    },

    IsTrue(choice) {
      if (choice == "true") {
        return "√";
      }
    },
    IsFalse(choice) {
      if (choice == "false") {
        return "√";
      }
    },

    OpenDialogConfirmSaveNurse() {
      if (this.advice != "" && this.nurseStatus != null) {
        this.dialogConfirmSaveNurse = true;
      }
    },

    OpenDailogNurse(formNo, title) {
      this.formNo = formNo;
      this.dialogNurseTitle = "";
      this.nurseRemark = "";
      this.advice = "";
      this.nurseStatus = null;

      this.dialogNurse = true;
      this.dialogNurseTitle = title;
    },

    async SaveNurse() {
      if (this.formNo == 1) {
        try {
          let q = {};
          q.p_id = this.$route.params.id;
          let res = await feathersClientUOA.service("mubadala-health-form-2").find({ query: q });
          if (res.total == 1) {
            let mhf_id = res.data[0].mhf_id;
            let dataUpdate = {
              mhf_status: this.nurseStatus.ns_name,
              mhf_advice: this.advice,
            };
            await feathersClientUOA.service("mubadala-health-form-2").patch(mhf_id, dataUpdate);
            //SEQ
            let properties = {
              f_id: parseInt(this.$route.params.f_id),
              p_id: parseInt(this.$route.params.id),
              mhf_id: parseInt(res.data[0].mhf_id),
              mhf_status: dataUpdate.mhf_status,
              mhf_advice: dataUpdate.mhf_advice
            };
            this.$log.Info('{action} by {username} ({role}) : f_id={f_id}, p_id={p_id}, mhf_id={mhf_id}, mhf_status={mhf_status}, mhf_advice={mhf_advice}', { action: "NurseReviewsMubadalaHealthForm", username: this.userdata.u_username, role: this.userdata.r_name, ...properties });
          }
        } catch (error) {
          //SEQ LOG
          this.$log.Error("NurseReviewsMubadalaHealthForm, Error : {error}", { error });
          console.log("NurseReviewsMubadalaHealthForm, Error : {error}" + error);
        }
      }

      // if (this.formNo == 2) {
      //   try {
      //     let q = {};
      //     q.p_id = this.$route.params.id;
      //     let res = await feathersClientUOA.service("mubadala-covid-form-2").find({ query: q });
      //     if (res.total == 1) {
      //       let mcf_id = res.data[0].mcf_id;
      //       let dataUpdate = {
      //         mcf_status: this.nurseStatus.ns_name,
      //       };
      //       await feathersClientUOA.service("mubadala-covid-form-2").patch(mcf_id, dataUpdate);
      //     }
      //   } catch (e) { }
      // }

      if (this.formNo == 3) {
        try {
          let q = {};
          q.p_id = this.$route.params.id;
          let res = await feathersClientUOA.service("mubadala-alcohol-form-2").find({ query: q });
          if (res.total == 1) {
            let maf_id = res.data[0].maf_id;
            let dataUpdate = {
              maf_status: this.nurseStatus.ns_name,
              maf_advice: this.advice
            };
            await feathersClientUOA.service("mubadala-alcohol-form-2").patch(maf_id, dataUpdate);
            //SEQ
            let properties = {
              f_id: parseInt(this.$route.params.f_id),
              p_id: parseInt(this.$route.params.id),
              maf_id: parseInt(res.data[0].maf_id),
              maf_status: dataUpdate.maf_status,
              maf_advice: dataUpdate.maf_advice
            };
            this.$log.Info('{action} by {username} ({role}) : f_id={f_id}, p_id={p_id}, maf_id={maf_id}, maf_status={maf_status}, maf_advice={maf_advice}', { action: "NurseReviewsMubadalaAlcoholForm", username: this.userdata.u_username, role: this.userdata.r_name, ...properties });
          }
        } catch (error) {
          //SEQ LOG
          this.$log.Error("NurseReviewsMubadalaAlcoholForm, Error : {error}", { error });
          console.log("NurseReviewsMubadalaAlcoholForm, Error : {error}" + error);
        }
      }

      await this.DataEForm();
      this.dialogNurse = false;
      this.dialogConfirmSaveNurse = false;
    },

    async RenderDeclarationForm() {
      var q = {};
      q.p_id = this.idPass;
      var resFind = await feathersClientUOA
        .service("decare-form")
        .find({ query: q });
      if (resFind.total > 0) {
        this.accept1 = resFind.data[0].dc_accept1;
        this.accept2 = resFind.data[0].dc_accept2;
        this.accept3 = resFind.data[0].dc_accept3;
        this.accept4 = resFind.data[0].dc_accept4;
        this.accept5 = resFind.data[0].dc_accept5;
        this.accept6 = resFind.data[0].dc_accept6;
        this.accept7 = resFind.data[0].dc_accept7;
        this.accept8 = resFind.data[0].dc_accept8;
        this.medicine1 = resFind.data[0].dc_medicine1;
        this.medicine2 = resFind.data[0].dc_medicine2;
        this.medicine3 = resFind.data[0].dc_medicine3;
        this.medicine4 = resFind.data[0].dc_medicine4;
        this.medicine5 = resFind.data[0].dc_medicine5;
        this.medicine6 = resFind.data[0].dc_medicine6;
        this.medicine7 = resFind.data[0].dc_medicine7;
        this.medicine8 = resFind.data[0].dc_medicine8;
        this.medicine9 = resFind.data[0].dc_medicine9;
        this.medicine10 = resFind.data[0].dc_medicine10;
        this.medicine11 = resFind.data[0].dc_medicine11;
        this.other = resFind.data[0].dc_other;
        this.otherDetail = resFind.data[0].dc_other_detail;
        this.consentDeclarationForm = resFind.data[0].dc_consent;
      }
    },

    async PrintDeclarationForm(type) {
      this.RenderDeclarationForm();

      let medicines = "";
      if (this.medicine1) {
        medicines += "ยาสามัญ ";
      }
      if (this.medicine2) {
        medicines += "พาราเซตามอล ";
      }
      if (this.medicine3) {
        medicines += "ยาความดัน ";
      }
      if (this.medicine4) {
        medicines += "ยาโรคเก๊าท์ ";
      }
      if (this.medicine5) {
        medicines += "ยาเบาหวาน ";
      }
      if (this.medicine6) {
        medicines += "วิตามิน ";
      }
      if (this.medicine7) {
        medicines += "อาหารเสริม ";
      }
      if (this.medicine8) {
        medicines += "ฟ้าทะลายโจร ";
      }
      if (this.medicine9) {
        medicines += "ยาแก้แพ้ ";
      }
      if (this.medicine10) {
        medicines += "ยาเมาเรือ ";
      }
      if (this.medicine11) {
        medicines += "ยาแก้ปวดเมื่อย ";
      }
      if (this.other) {
        medicines += this.otherDetail;
      }

      var customerlogo = await this.$LogoService.GetLogoBaseurl64(4);

      //Signature
      var qp = {};
      qp.p_id = this.idPass;
      var res = await feathersClientUOA
        .service("viewcheckinpassenger-2")
        .find({ query: qp });
      this.signImage = res.data[0].p_checkin_signature;
      this.signDateTime = res.data[0].p_checkin_date;

      var pdfMake = require("../../public/js/pdfmake");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("../../public/js/vfs_fonts");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew-Bold.ttf",
          italics: "THSarabunNew-Italic.ttf",
          bolditalics: "THSarabunNew-BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      var docDefinitionyComplianceDeclarationForm = {
        images: {
          signatureImage: this.signImage,
        },
        content: [
          {
            style: "tableExample",
            table: {
              widths: ["auto", "auto", "*"],
              body: [
                [
                  {
                    width: 122 * 0.4,
                    height: 74 * 0.4,
                    alignment: "left",
                    image:
                      "data:image/png;base64,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",
                  },
                  {
                    text: "",
                  },
                  {
                    width: customerlogo.w * 2.32,
                    height: customerlogo.h * 2.32,
                    alignment: "right",
                    margin: [15, 0, 0, 0],
                    image: customerlogo.logo,
                  },
                ],
                ["", "", ""],
              ],
            },
            layout: "headerLineOnly",
          },
          {
            style: "tableHeader",
            table: {
              widths: ["*", "auto", "*"],
              body: [
                [
                  {
                    text: "",
                    alignment: "left",
                  },
                  {
                    text: "แบบสำแดงยืนยันปฏิบัติตามนโยบายด้านสิ่งเสพติดและแอลกอฮอล์",
                    fontSize: 14,
                    bold: true,
                    margin: [0, 0, 0, 0],
                    alignment: "center",
                  },
                  {
                    text: "",
                    alignment: "right",
                  },
                ],
                [
                  {
                    text: "",
                    alignment: "left",
                  },
                  {
                    text: "Drugs & Alcohol Policy Compliance Declaration Form",
                    fontSize: 14,
                    bold: true,
                    margin: [0, 0, 0, 0],
                    alignment: "center",
                  },
                  {
                    text: "",
                    alignment: "right",
                  },
                ],
              ],
            },
            layout: "headerLineOnly",
          },
          {
            style: "tableTransportMode",
            table: {
              headerRows: 1,
              widths: ["*", "auto", "auto"],
              body: [
                [
                  {
                    text: "",
                    border: [false, false, false, false],
                  },
                  {
                    image:
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzA2MEU3NzY5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzA2MEU3Nzc5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDMDYwRTc3NDlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDMDYwRTc3NTlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PreteusAAABpSURBVHjaYvz//z8DLQETA40BzS1gAAURDAOBBxA/BgmTiUF6PVDMRLPgEQWGw/AjZDMZkSOZkZHxP9RXjOSEBjb9Qz+SRy0YtWDUglELiAAsaHxQeS4LKxXJBI/pWuEwjlb6hABAgAEAF698FDGkuJwAAAAASUVORK5CYII=",
                    width: 13,
                    alignment: "right",
                    border: [false, false, false, false],
                  },
                  {
                    text: "HQ",
                    alignment: "left",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          {
            style: "tableInformation",
            table: {
              headerRows: 1,
              widths: ["auto", "*", "*", "auto", "*"],
              body: [
                [
                  {
                    text: "ชื่อ-นามสกุล\r\nFull name:",
                    fontSize: 12,
                    bold: true,
                    alignment: "left",
                  },
                  {
                    text: this.fullname,
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 2,
                  },
                  {
                    text: "",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "ชื่อบริษัท\r\nCompany name:",
                    fontSize: 12,
                    bold: true,
                    alignment: "left",
                  },
                  {
                    text: this.companyName,
                    fontSize: 12,
                    alignment: "left",
                  },
                ],
                [
                  {
                    text: "ปลายทาง\r\nDestination:",
                    fontSize: 12,
                    bold: true,
                    alignment: "left",
                  },
                  {
                    text: this.destination,
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 2,
                  },
                  {
                    text: "",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "เดินทางโดย\r\nTransport Mode:",
                    fontSize: 12,
                    bold: true,
                    alignment: "left",
                  },
                  {
                    table: {
                      headerRows: 1,
                      widths: ["auto", "auto", "auto", "auto"],
                      body: [
                        [
                          {
                            image:
                              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAdklEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5KmoQYc0DVEMfxjqiNcAUv6foYZYDQjleDRoYlWOU0Mdw2+GECzKcWpoAZK/GUIxlONxUjNYC7pyvJ5uBrNrSIm4JgzltE0aOORJTt4kZ6BBBAADNZmOfmKY6QAAAABJRU5ErkJggg==",
                            width: 13,
                            alignment: "right",
                            border: [false, false, false, false],
                          },

                          {
                            text: "Helicopter",
                            fontSize: 12,
                            alignment: "left",
                            border: [false, false, false, false],
                          },
                          {
                            image:
                              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzA2MEU3NzY5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzA2MEU3Nzc5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDMDYwRTc3NDlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDMDYwRTc3NTlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PreteusAAABpSURBVHjaYvz//z8DLQETA40BzS1gAAURDAOBBxA/BgmTiUF6PVDMRLPgEQWGw/AjZDMZkSOZkZHxP9RXjOSEBjb9Qz+SRy0YtWDUglELiAAsaHxQeS4LKxXJBI/pWuEwjlb6hABAgAEAF698FDGkuJwAAAAASUVORK5CYII=",
                            width: 13,
                            alignment: "right",
                            border: [false, false, false, false],
                          },
                          {
                            text: "Boat",
                            border: [false, false, false, false],
                          },
                        ],
                      ],
                    },
                  },
                ],
              ],
            },
          },

          /*Start ProhibitedDrugs*/
          {
            style: "tableTitleProhibitedDrugs",
            table: {
              headerRows: 1,
              widths: ["*"],
              body: [
                [
                  {
                    text: "1) ท่านมีสารหรือสิ่งเสพติดต้องห้ามดังต่อไปนี้ในสัมภาระหรือพกพาที่ต้องสำแดงหรือไม่?\r\nDo you have any of the following substances in your possession or in baggage to declare? (ทำเครื่องหมาย Mark √)",
                    fontSize: 14,
                    border: [false, false, false, false],
                    alignment: "left",
                  },
                ],
              ],
            },
          },
          {
            style: "tableProhibitedDrugs",
            table: {
              headerRows: 1,
              widths: ["*", "*", "*", "*", "*", "*", "*", "*", "*", "*"],
              body: [
                [
                  {
                    text: "สารหรือสิ่งเสพติดต้องห้าม",
                    fontSize: 12,
                    bold: true,
                    alignment: "center",
                    colSpan: 4,
                  },
                  {
                    text: "2",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Prohibited drugs / substances",
                    fontSize: 12,
                    bold: true,
                    alignment: "center",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "มี\r\nYes",
                    fontSize: 12,
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "ไม่มี\nNo",
                    fontSize: 12,
                    bold: true,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "1",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "กัญชา, กระท่อม, กัญชง",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Marijuana, Cannabis, Kratom, Hemp",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: this.IsTrue(this.accept1),
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: this.IsFalse(this.accept1),
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "2",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "โคเคน ฝิ่น เฮโรอีน",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Cocaine, Opiates, Heroine",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: this.IsTrue(this.accept2),
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: this.IsFalse(this.accept2),
                    fontSize: 14,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "มอร์ฟีน ยาบ้า",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Morphine, Amphetamine",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: this.IsTrue(this.accept3),
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: this.IsFalse(this.accept3),
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "ยาอี ยาไอซ์",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Ecstasy, Methylenedioxyamphetamine",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: this.IsTrue(this.accept4),
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: this.IsFalse(this.accept4),
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "** หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับสิ่งที่พกมาด้วย เช่น ยารักษาโรคหรืออาหารเสริม กรุณาสำแดงและสอบถามติดต่อเจ้าหน้าที่\r\nIf you have any medicines or food supplements on you and in doubts, please declare and contact check-in staff.",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 10,
                  },
                  {
                    text: "2",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "5",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "9",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "10",
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
              ],
            },
          },
          /*End ProhibitedDrugs */

          /*Start Alcohol_beverages */
          {
            style: "tableTitleProhibitedDrugs",
            table: {
              headerRows: 1,
              widths: ["*"],
              body: [
                [
                  {
                    text: "\r\n",
                    fontSize: 0.5,
                    border: [false, false, false, false],
                  },
                ],
                [
                  {
                    text: "2) ท่านได้นำของเหลวหรือเครื่องดื่มดังต่อไปนี้ติดในสัมภาระหรือพกพาที่ต้องสำแดงหรือไม่\r\nDo you have any of the following alcohol beverages on you or in baggage to declare? (ทำเครื่องหมาย Mark √)",
                    fontSize: 14,
                    border: [false, false, false, false],
                    alignment: "left",
                  },
                ],
              ],
            },
          },
          {
            style: "tableProhibitedDrugs",
            table: {
              headerRows: 1,
              widths: ["*", "*", "*", "*", "*", "*", "*", "*", "*", "*"],
              body: [
                [
                  {
                    text: "เครื่องดื่มที่มีส่วนผสมแอลกอฮอล์",
                    fontSize: 12,
                    bold: true,
                    alignment: "center",
                    colSpan: 4,
                  },
                  {
                    text: "2",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Prohibited Alcohol Mixed/Based Beverages",
                    fontSize: 12,
                    bold: true,
                    alignment: "center",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "มี\r\nYes",
                    fontSize: 12,
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "ไม่มี\r\nNo",
                    fontSize: 12,
                    bold: true,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "1",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "วิสกี้, ไวน์, บรั่นดี, รัม",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Whiskey, wine, brandy, rum,",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: this.IsTrue(this.accept5),
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: this.IsFalse(this.accept5),
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "2",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "สาโท, อุ, กะแช่",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Malt, booze, liquor",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: this.IsTrue(this.accept6),
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: this.IsFalse(this.accept6),
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "เบียร์, เบียร์ 0% แอลกอฮอล์, สาเก",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Beers, 0% alcohol beer, sake",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: this.IsTrue(this.accept7),
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: this.IsFalse(this.accept7),
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "ไวน์คูลเลอร์, เครื่องดื่มหมักยีสต์ทุกประเภท",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "Wine Cooler, any alcohol content beverages",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: this.IsTrue(this.accept8),
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: this.IsFalse(this.accept8),
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "** หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับสิ่งที่พกมาด้วย เช่น ยารักษาโรคหรืออาหารเสริม กรุณาสำแดงและสอบถามติดต่อเจ้าหน้าที่\r\nIf you have any medicines or food supplements on you and in doubts, please declare and contact check-in staff.",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 10,
                  },
                  {
                    text: "2",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 3,
                  },
                  {
                    text: "3",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "4",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "5",
                    fontSize: 12,
                    alignment: "left",
                    colSpan: 4,
                  },
                  {
                    text: "6",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "7",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "8",
                    fontSize: 12,
                    alignment: "left",
                  },
                  {
                    text: "9",
                    fontSize: 12,
                    alignment: "center",
                  },
                  {
                    text: "10",
                    fontSize: 12,
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: "",
                    fontSize: 0.5,
                    alignment: "center",
                    colSpan: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                ],
              ],
            },
          },
          /*End Alcohol_beverages  */

          {
            style: "tableDeclaredItems",
            table: {
              headerRows: 1,
              widths: ["auto", "*"],
              body: [
                [
                  {
                    text: "รายการที่สำแดง (ถ้ามี)\r\n Declared items (if any)",
                    fontSize: 12,
                  },
                  {
                    text: medicines,
                    fontSize: 12,
                  },
                ],
                [
                  {
                    text: "",
                    fontSize: 0.5,
                    border: [false, false, false, false],
                    colSpan: 2,
                  },
                ],
              ],
            },
          },

          {
            style: "tableSignature",
            table: {
              headerRows: 1,
              widths: ["*", "*", "*"],
              body: [
                [
                  {
                    text: "ข้าพเจ้ายินดีปฏิบัติตามนโยบายของบริษัท และขอยืนยันว่าข้อมูลที่สำแดงตามแบบสอบถามข้างบนเป็นจริงทุกประการ\r\nI acknowledge the Company’s Drugs and Alcohol Policy and hereby declare and confirm all answers are correct and true.",
                    alignment: "left",
                    colSpan: 3,
                    fontSize: 12,
                  },
                  {
                    text: "",
                  },
                  {
                    text: "",
                  },
                ],
                [
                  {
                    text: "ลงลายมือชื่อ\r\nSignature:",
                    alignment: "left",
                    fontSize: 12,
                  },
                  {
                    image: "signatureImage",
                    width: 80,
                    alignment: "center",
                  },
                  {
                    text:
                      "วันที่ Date: " +
                      format(new Date(this.signDateTime), "dd/MM/yyy HH:mm"),
                    fontSize: 12,
                  },
                ],
              ],
            },
          },
          { text: "INTERNAL", color: "red", size: 50 },
        ],
        styles: {},
        defaultStyle: {
          font: "THSarabunNew",
        },
      };

      if (type == 1) {
        pdfMake.createPdf(docDefinitionyComplianceDeclarationForm).open({});
      } else {
        pdfMake
          .createPdf(docDefinitionyComplianceDeclarationForm)
          .download("ComplianceDeclarationForm.pdf");
      }
    },

    async PrintHealthForm(type) {
      Nurseform.PrintHealthForm(this.idPass, type)
    },
    async PrintCovidForm(type) {
      Nurseform.PrintCovidForm(this.idPass, type)
    },
    async PrintAlcoholForm(type) {
      Nurseform.PrintAlcoholForm(this.idPass, type)
    },
    async Cancleform() {
      var q2 = {}
      q2.p_id = this.idPass;
      switch (this.fromdel) {
        case 1:
          var res2 = await feathersClientUOA
            .service("mubadala-health-form-2")
            .find({ query: q2 });
          var datainsert = {}
          datainsert.p_id = this.idPass;
          datainsert.mdfl_form_name = "Medicine Declaration Form"
          datainsert.mdfl_delete_by = this.userdata.FullName;
          datainsert.mdfl_data_before_delete = JSON.stringify(res2.data[0])
          var result = await feathersClientUOA
            .service("mubadala-delete-form-log")
            .create(datainsert);
          var remove = await feathersClientUOA
            .service("mubadala-health-form-2")
            .remove(res2.data[0].mhf_id);
          console.log(remove)
          break;
        case 2:
          var res2 = await feathersClientUOA
            .service("mubadala-covid-form-2")
            .find({ query: q2 });
          var datainsert = {}
          datainsert.p_id = this.idPass;
          datainsert.mdfl_form_name = "Medicine Declaration Form"
          datainsert.mdfl_delete_by = this.userdata.FullName;
          datainsert.mdfl_data_before_delete = JSON.stringify(res2.data[0])
          var result = await feathersClientUOA
            .service("mubadala-delete-form-log")
            .create(datainsert);
          var remove = await feathersClientUOA
            .service("mubadala-covid-form-2")
            .remove(res2.data[0].mcf_id);
          console.log(remove)
          break;
        case 3:
          q2.$eager = "[mubadala_alcohol_form_detail]";
          var res2 = await feathersClientUOA
            .service("mubadala-alcohol-form-2")
            .find({ query: q2 });
          var datainsert = {}
          datainsert.p_id = this.idPass;
          datainsert.mdfl_form_name = "Medicine Declaration Form"
          datainsert.mdfl_delete_by = this.userdata.FullName;
          datainsert.mdfl_data_before_delete = JSON.stringify(res2.data[0])
          var result = await feathersClientUOA
            .service("mubadala-delete-form-log")
            .create(datainsert);
          var remove = await feathersClientUOA
            .service("mubadala-alcohol-form-2")
            .remove(res2.data[0].maf_id);
          res2.data[0].mubadala_alcohol_form_detail.forEach(async x => {
            var remove = await feathersClientUOA
              .service("mubadala-alcohol-form-detail-2")
              .remove(x.mafd_Id);
          })
          console.log(remove)
          break;

      }
      this.dialogConfirmDelete = false;
      this.DataEForm();
    },
  },
};
</script>

<style scoped>
.btn-checkin {
  background-color: #6c63ff !important;
}

.btn-viewcheckin {
  background-color: #00ba48 !important;
}

.btn-delete {
  background-color: #ff0001 !important;
}

td {
  padding: 7px;
}

th {
  color: red;
}

.boxstatuspassed {
  color: white;
  background-color: green;
  border-radius: 10px;
  text-align: center;
  width: 100px;
  height: 25px;
  justify-content: center;
  margin: auto;
  width: 50%;
}

.boxstatusfailed {
  color: white;
  background-color: red;
  border-radius: 10px;
  text-align: center;
  width: 100px;
  height: 25px;
  justify-content: center;
  margin: auto;
  width: 50%;
}
</style>
